import { useEffect, useState } from "react";
import { smoothScrollTo } from "../../hooks/useLenis";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_healthcare-roi/artifacts/p70436tc_Emerald%20Heartbeat%20Line%20Logo%20for%20ProCliniq%20%281%29.png";

const NAV = [
  { id: "services", label: "Services" },
  { id: "roi", label: "ROI" },
  { id: "book", label: "Book a call" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => (e) => {
    e.preventDefault();
    smoothScrollTo(id, -60);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-slate-950/70 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={goTo("top")}
          data-testid="brand-link"
          aria-label="ProCliniq home"
          className="flex items-center group"
        >
          <div
            className="h-10 w-48 sm:w-56 rounded-sm bg-no-repeat transition-transform duration-500 group-hover:scale-[1.02]"
            style={{
              backgroundImage: `url(${LOGO_URL})`,
              backgroundSize: "auto 320%",
              backgroundPosition: "center 50%",
            }}
            role="img"
            aria-label="ProCliniq"
          />
        </a>

        <div className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              onClick={goTo(n.id)}
              data-testid={`nav-${n.id}-link`}
              className="relative text-sm text-slate-300 hover:text-white transition-colors tracking-tight after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-full after:bg-white after:origin-left after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-500"
            >
              {n.label}
            </a>
          ))}
        </div>

        <a
          href="#book"
          onClick={goTo("book")}
          data-testid="header-cta-button"
          className="group inline-flex items-center gap-2 bg-white text-slate-950 hover:bg-slate-200 transition-colors font-medium rounded-sm px-4 sm:px-5 py-2.5 text-sm"
        >
          Book a call
          <span className="w-1 h-1 rounded-full bg-slate-950 group-hover:scale-150 transition-transform" />
        </a>
      </nav>
    </header>
  );
}
